import type { UserPayload } from '@/store/types/UserPayload'
import { put } from '@/backend/api'
import { isErrorResponse } from '@/backend/error/types'
import { errorMessages, parseError } from '@/backend/error'
import type { ApiResult } from './types'

type Params = {
  first_name?: string
  last_name?: string

  two_factor_auth_enabled?: boolean

  old_password?: string
  password?: string
  password_confirmation?: string

  hash?: string

  show_notifications?: boolean
}
export const updateProfile = async (params: Params): Promise<ApiResult<UserPayload>> => {
  try {
    const response = await put<UserPayload>('users/profile', params)
    return { data: response.data, ok: true }
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }
    return {
      ...parseError(error, errorMessages.PROFILE_UPDATE),
      ok: false,
    }
  }
}
